import React from "react";
import PropTypes from "prop-types";
import { scoreFmt } from "pages/AppraisalManagment/utils/appraisalAverageRating";

const navy = "#1A1B2F";
const sectionBar = {
  background: navy,
  color: "#fff",
  padding: "10px 16px",
  fontWeight: 600,
  fontSize: "13px",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  textAlign: "center",
};

const AverageRatingCalculationTable = ({
  resultsRows,
  totalAppraisal,
  overallScore,
  titlePrefix = "Overall Results Points",
}) => {
  if (!resultsRows?.length) return null;

  const headerText =
    overallScore != null && overallScore !== ""
      ? `${titlePrefix} - Overall score: ${overallScore}%`
      : titlePrefix;

  return (
    <div
      style={{
        marginBottom: "20px",
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <div style={sectionBar}>{headerText}</div>
      <div className="table-responsive">
        <table className="table mb-0" style={{ borderColor: "#E5E7EB" }}>
          <thead>
            <tr style={{ background: "#F0F2F5" }}>
              <th
                style={{
                  borderColor: "#E5E7EB",
                  fontWeight: 600,
                  padding: "10px 12px",
                  textAlign: "left",
                }}
              >
                Section
              </th>
              <th
                style={{
                  borderColor: "#E5E7EB",
                  fontWeight: 600,
                  padding: "10px 12px",
                  textAlign: "right",
                }}
              >
                Average Rating
              </th>
              <th
                style={{
                  borderColor: "#E5E7EB",
                  fontWeight: 600,
                  padding: "10px 12px",
                  textAlign: "right",
                }}
              >
                Weighted Points
              </th>
            </tr>
          </thead>
          <tbody>
            {resultsRows.map((row) => (
              <tr key={row.key}>
                <td style={{ borderColor: "#E5E7EB", padding: "10px 12px" }}>{row.label}</td>
                <td
                  style={{
                    borderColor: "#E5E7EB",
                    padding: "10px 12px",
                    textAlign: "right",
                  }}
                >
                  {scoreFmt(row.avgRating)}
                </td>
                <td
                  style={{
                    borderColor: "#E5E7EB",
                    padding: "10px 12px",
                    textAlign: "right",
                  }}
                >
                  {scoreFmt(row.weighted)}
                </td>
              </tr>
            ))}
            <tr style={{ background: "#F0F2F5", fontWeight: 700 }}>
              <td style={{ borderColor: "#E5E7EB", padding: "10px 12px" }}>
                Total Appraisal Rating
              </td>
              <td style={{ borderColor: "#E5E7EB" }} />
              <td
                style={{
                  borderColor: "#E5E7EB",
                  padding: "10px 12px",
                  textAlign: "right",
                }}
              >
                {scoreFmt(totalAppraisal)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

AverageRatingCalculationTable.propTypes = {
  resultsRows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      avgRating: PropTypes.number.isRequired,
      weighted: PropTypes.number.isRequired,
    })
  ),
  totalAppraisal: PropTypes.number,
  overallScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  titlePrefix: PropTypes.string,
};

export default AverageRatingCalculationTable;
